window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

require('es6-promise/auto');

let cart = window.localStorage.getItem('cart');

let cartCount = window.localStorage.getItem('cartCount');

let cartPromocode = window.sessionStorage.getItem('cartPromocode');

let location = window.localStorage.getItem('location');

if (location === null || location.length < 1) {
    let moscow = {"value":"г Москва","unrestricted_value":"г Москва","data":{"postal_code":null,"country":"Россия","country_iso_code":"RU","federal_district":null,"region_fias_id":"0c5b2444-70a0-4932-980c-b4dc0d3f02b5","region_kladr_id":"7700000000000","region_iso_code":"RU-MOW","region_with_type":"г Москва","region_type":"г","region_type_full":"город","region":"Москва","area_fias_id":null,"area_kladr_id":null,"area_with_type":null,"area_type":null,"area_type_full":null,"area":null,"city_fias_id":"0c5b2444-70a0-4932-980c-b4dc0d3f02b5","city_kladr_id":"7700000000000","city_with_type":"г Москва","city_type":"г","city_type_full":"город","city":"Москва","city_area":null,"city_district_fias_id":null,"city_district_kladr_id":null,"city_district_with_type":null,"city_district_type":null,"city_district_type_full":null,"city_district":null,"settlement_fias_id":null,"settlement_kladr_id":null,"settlement_with_type":null,"settlement_type":null,"settlement_type_full":null,"settlement":null,"street_fias_id":null,"street_kladr_id":null,"street_with_type":null,"street_type":null,"street_type_full":null,"street":null,"house_fias_id":null,"house_kladr_id":null,"house_type":null,"house_type_full":null,"house":null,"block_type":null,"block_type_full":null,"block":null,"flat_fias_id":null,"flat_type":null,"flat_type_full":null,"flat":null,"flat_area":null,"square_meter_price":null,"flat_price":null,"postal_box":null,"fias_id":"0c5b2444-70a0-4932-980c-b4dc0d3f02b5","fias_code":"7700000000000000000","fias_level":"1","fias_actuality_state":"0","kladr_id":"7700000000000","geoname_id":"524894","capital_marker":"0","okato":"45000000000","oktmo":"45000000","tax_office":"7700","tax_office_legal":"7700","timezone":null,"geo_lat":"55.75396","geo_lon":"37.620393","beltway_hit":null,"beltway_distance":null,"metro":null,"qc_geo":null,"qc_complete":null,"qc_house":null,"history_values":null,"unparsed_parts":null,"source":null,"qc":null},"delivery":{"boxberry_id":"68","cdek_id":"44","dpd_id":"49694102"}};
    location = JSON.stringify(moscow);
    window.localStorage.setItem('location', JSON.stringify(moscow));

    axios.get('https://ipinfo.io/json', {
            'headers': {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then((response) => {
            if (response.data.ip) {
                axios.get('/api/dadata/location/ip/get?ip=' + response.data.ip)
                    .then((res) => {
                        location = JSON.stringify(res.data.location);
                        window.localStorage.setItem('location', JSON.stringify(res.data.location));
                    })
            } else {
                let moscow = {"value":"г Москва","unrestricted_value":"г Москва","data":{"postal_code":null,"country":"Россия","country_iso_code":"RU","federal_district":null,"region_fias_id":"0c5b2444-70a0-4932-980c-b4dc0d3f02b5","region_kladr_id":"7700000000000","region_iso_code":"RU-MOW","region_with_type":"г Москва","region_type":"г","region_type_full":"город","region":"Москва","area_fias_id":null,"area_kladr_id":null,"area_with_type":null,"area_type":null,"area_type_full":null,"area":null,"city_fias_id":"0c5b2444-70a0-4932-980c-b4dc0d3f02b5","city_kladr_id":"7700000000000","city_with_type":"г Москва","city_type":"г","city_type_full":"город","city":"Москва","city_area":null,"city_district_fias_id":null,"city_district_kladr_id":null,"city_district_with_type":null,"city_district_type":null,"city_district_type_full":null,"city_district":null,"settlement_fias_id":null,"settlement_kladr_id":null,"settlement_with_type":null,"settlement_type":null,"settlement_type_full":null,"settlement":null,"street_fias_id":null,"street_kladr_id":null,"street_with_type":null,"street_type":null,"street_type_full":null,"street":null,"house_fias_id":null,"house_kladr_id":null,"house_type":null,"house_type_full":null,"house":null,"block_type":null,"block_type_full":null,"block":null,"flat_fias_id":null,"flat_type":null,"flat_type_full":null,"flat":null,"flat_area":null,"square_meter_price":null,"flat_price":null,"postal_box":null,"fias_id":"0c5b2444-70a0-4932-980c-b4dc0d3f02b5","fias_code":"7700000000000000000","fias_level":"1","fias_actuality_state":"0","kladr_id":"7700000000000","geoname_id":"524894","capital_marker":"0","okato":"45000000000","oktmo":"45000000","tax_office":"7700","tax_office_legal":"7700","timezone":null,"geo_lat":"55.75396","geo_lon":"37.620393","beltway_hit":null,"beltway_distance":null,"metro":null,"qc_geo":null,"qc_complete":null,"qc_house":null,"history_values":null,"unparsed_parts":null,"source":null,"qc":null},"delivery":{"boxberry_id":"68","cdek_id":"44","dpd_id":"49694102"}};
                location = JSON.stringify(moscow);
                window.localStorage.setItem('location', JSON.stringify(moscow));
            }
        })
        .catch(error => {
            console.log(error);
        });
}

let customer = window.localStorage.getItem('customer');

const state = {
    /**
     * Товары в корзине
     */
    cart: cart ? JSON.parse(cart) : [],

    /**
     * Количество товара в корзине
     */
    cartCount: cartCount ? parseInt(cartCount) : 0,

    /**
     * Товар в модальном окне при добавлении к корзину
     */
    modalAddCart: [],

    /**
     * Промокод в корзине
     */
    cartPromocode: cartPromocode ? JSON.parse(cartPromocode) : {},

    /**
     * Фильтр в модальном окне
     */
    modalFilter: false,

    /**
     * Локация доставки
     */
    location: location ? JSON.parse(location) : [],

    /**
     * Модальное окно выбора локации
     */
    modalLocation: false,

    /**
     * Модальное окно авторизации
     */
    modalLogin: false,

    /**
     * Модальное окно сообщить о поступлении
     */
    modalProductPreorder: false,
    modalProductPreorderName: '',

    /**
     * Лоадер на весь сайт
     */
    globalLoading: false,

    /**
     * Покупатель
     */
    customer: customer ? JSON.parse(customer) : {},
};
const getters = {};
const actions = {
    /**
     * Добавление товара в корзину
     * @param state
     * @param commit
     * @param product
     */
    addToCart({state, commit}, product) {
        commit('addToCart', product);

        state.modalAddCart = product;
        setTimeout(() => state.modalAddCart = [], 2000);

        commit('saveCart');
    },

    /**
     * Удаление товара из корзины
     * @param commit
     * @param product
     */
    removeFromCart({commit}, product) {
        commit('removeFromCart', product);

        commit('saveCart');
    },

    /**
     * Показать модальное окно выбора локации
     */
    showModalLocation({state}) {
        state.modalLocation = true;
    },

    /**
     * Скрыть модальное окно выбора локации
     */
    hideModalLocation({state}) {
        state.modalLocation = false;
    },

    /**
     * Показать модальное окно авторизации
     */
    showModalLogin({state}) {
        state.modalLogin = true;
    },

    /**
     * Скрыть модальное окно авторизации
     */
    hideModalLogin({state}) {
        state.modalLogin = false;
    },

    /**
     * Показать модальное окно сообщить о поступлении
     */
    showModalProductPreorder({state}, product) {
        state.modalProductPreorder = true;
        state.modalProductPreorderName = product;
    },

    /**
     * Скрыть модальное окно сообщить о поступлении
     */
    hideModalProductPreorder({state}) {
        state.modalProductPreorder = false;
        state.modalProductPreorderName = '';
    },

    /**
     * Показать лоадер на весь сайт
     */
    showGlobalLoading({state}) {
        state.globalLoading = true;
    },

    /**
     * Скрыть лоадер на весь сайт
     */
    hideGlobalLoading({state}) {
        state.globalLoading = false;
    },

    /**
     * Отчистить корзину
     */
    cleanCart({state, commit}) {
        state.cart = [];
        state.cartCount = 0;
        commit('saveCart');
    },

    /**
     * Увеличить количество товара в корзине
     */
    plusQuantityInCart({state, commit}, variant_id) {
        let found = state.cart.find(in_cart_product => in_cart_product.variant_id === variant_id);
        if (found) {
            found.in_cart_quantity += 1;
            found.in_cart_total_price = found.in_cart_quantity * found.total_price;
            state.cartCount += 1;
            commit('saveCart');
        }
    },

    /**
     * Уменьшить количество товара в корзине
     */
    minusQuantityInCart({state, commit}, variant_id) {
        let found = state.cart.find(in_cart_product => in_cart_product.variant_id === variant_id);
        if (found && found.in_cart_quantity > 1) {
            found.in_cart_quantity -= 1;
            found.in_cart_total_price = found.in_cart_quantity * found.total_price;
            state.cartCount -= 1;
            commit('saveCart');
        }
    },

    /**
     * Добавление промокода
     */
    addPromocode({state, commit}, promocode) {
        state.cartPromocode = promocode;
        commit('addPromocodeCart', promocode);
    },

    /**
     * Удаление промокода из state и local storage
     */
    deletePromocode(state) {
        window.sessionStorage.removeItem('cartPromocode');
        state.cartPromocode = {};
    },

    /**
     * Обновление цен в корзине
     */
    async updateCartPrice({commit}) {
        await commit('updateCartPrice');
        commit('saveCart');
    },

    async updateCart({state, commit, dispatch}) {
        let products = state.cart;
        let promocode = state.cartPromocode;

        dispatch('showGlobalLoading');

        for (const product of products) {
            await axios.get('/api/frontend/variant/get?variant_id=' + product.variant_id)
                .then((response) => {
                    //сверяем остатки на складе
                    product.quantity = response.data.quantity;
                    //пересчитываем максимальное количество
                    if (product.in_cart_quantity > response.data.quantity && response.data.quantity > 0) {
                        state.cartCount -= product.in_cart_quantity - response.data.quantity;
                        product.in_cart_quantity = response.data.quantity;
                    }
                    //обновляем остальное
                    product.discount = response.data.product.discount;
                    product.discount_type = response.data.product.discount_type;
                    product.price = response.data.price;
                    product.total_price = response.data.total_price;
                    product.in_cart_total_price = response.data.total_price * product.in_cart_quantity;
                    product.active = response.data.product.active;
                })
                .catch(error => {
                    console.log(error);
                });
        }

        //удаляем товары которых нет в наличии
        products.forEach(function(product, index) {
            if (product.active !== 1) {
                products.splice(index, 1);
                state.cartCount -= product.in_cart_quantity;
            }
        });

        commit('saveCart');

        if (promocode.id) {
            commit('addPromocodeCart', promocode);
        }

        dispatch('hideGlobalLoading');
    }
};
const mutations = {
    /**
     * Сохраняет корзину и счетчик корзины в Local Storage
     * @param state
     */
    saveCart(state) {
        window.localStorage.setItem('cart', JSON.stringify(state.cart));
        window.localStorage.setItem('cartCount', state.cartCount);
    },
    /**
     * Добавление товара в корзину
     * @param state
     * @param product
     */
    addToCart(state, product) {
        let found = state.cart.find(in_cart_product => in_cart_product.variant_id === product.variant_id);
        if (found) {
            found.in_cart_quantity += parseInt(product.quantity);
            found.in_cart_total_price = found.in_cart_quantity * parseInt(product.total_price);
        } else {
            state.cart.push(product);
            Vue.set(product, 'in_cart_quantity', parseInt(product.quantity));
            Vue.set(product, 'in_cart_total_price', parseInt(product.total_price) * parseInt(product.quantity));
        }
        state.cartCount += parseInt(product.quantity);
    },
    /**
     * Удаление товара из корзины
     */
    removeFromCart(state, payload) {
        let index = state.cart.indexOf(payload);
        if (index > -1) {
            let product = state.cart[index];
            state.cartCount -= product.in_cart_quantity;

            state.cart.splice(index, 1);
        }
    },
    /**
     * Изменение цен в корзине при активации промокода
     */
    addPromocodeCart(state, promocode) {
        let products = state.cart;
        products.forEach(function(product) {
            if (product.discount === 0) {
                if (promocode.type_id === 2 && promocode.product_categories.length > 0) {
                    if (promocode.product_categories.length > 0) {
                        axios.get('/api/frontend/products/is-product-in-categories', {
                            params: {
                                'product_id': product.product_id,
                                'categories_ids': promocode.product_categories
                            }
                        }).then((response) => {
                            if (response.data === 1) {
                                product.discount = promocode.sale;
                                product.discount_type = 'promocode';
                                product.total_price = product.total_price - Math.ceil(product.price * promocode.sale / 100);
                                product.in_cart_total_price = product.total_price * product.in_cart_quantity;
                            }
                        }).catch(error => {
                            console.log(error);
                        });
                    }
                } else if (promocode.type_id === 3 && promocode.products.length > 0) {
                    if (promocode.products.includes(product.product_id)) {
                        product.discount = promocode.sale;
                        product.discount_type = 'promocode';
                        product.total_price = product.total_price - Math.ceil(product.price * promocode.sale / 100);
                        product.in_cart_total_price = product.total_price * product.in_cart_quantity;
                    }
                } else {
                    product.discount = promocode.sale;
                    product.discount_type = 'promocode';
                    product.total_price = product.total_price - Math.ceil(product.price * promocode.sale / 100);
                    product.in_cart_total_price = product.total_price * product.in_cart_quantity;
                }
                Vue.set(product, 'promocode', promocode);
            }
        });
    },
    /**
     * Проверка цен в корзине
     */
    async updateCartPrice(state) {
        let products = state.cart;

        for (const product of products) {
            await axios.get('/api/frontend/variant/get?variant_id=' + product.variant_id)
                .then((response) => {
                    product.discount = response.data.product.discount;
                    product.price = response.data.price;
                    product.total_price = response.data.total_price;
                    product.in_cart_total_price = response.data.total_price * product.in_cart_quantity;
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
